import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import mainAxios from '../../services/mainAxios';
import func from '../../services/functions';
import Loader from '../Layout/Loader';
import Company from '../Companies/Company/Company';
import useSettingsCompany from './useSettingsCompany';
import SettingsBreadcrumb from './SettingsBreadcrumb';
import './settings.scss';

const GeneralInfoSettings = () => {
  const { t } = useTranslation('translations');
  const {
    company,
    setCompany,
    getCompany: reloadCompany,
    loading: companyLoading,
    isAdminMode,
    getBackUrl,
    user,
    selectedCompany,
  } = useSettingsCompany();

  const [pageLoading, setPageLoading] = useState(true);
  const [logoLoading, setLogoLoading] = useState(true);
  const [filePreview, setFilePreview] = useState(null);

  const getCompany = ({ reload = false, reloadParameters = true } = {}) => {
    if (!company?.id) return;
    if (reload === false) {
      if (reloadParameters) getLogo(company);
      setPageLoading(false);
      return;
    }
    reloadCompany({ reload: true });
    if (reloadParameters) getLogo(company);
    setPageLoading(false);
  };

  const editCompany = ({ newCompany } = {}) => {
    return mainAxios
      .post('apiEndpoint/saveOrUpdate', {
        object: 'Company',
        content: newCompany ?? {
          ...company,
        },
        nuis: user.companiesRights.find(
          (c) => c.id === parseInt(selectedCompany)
        )?.nuis,
      })
      .then((res) => {
        if (res?.data?.status === true) {
          return true;
        }
        return false;
      })
      .catch(() => {
        return false;
      });
  };

  useEffect(() => {
    if (company?.id && !companyLoading) {
      setFilePreview(null);
      getCompany();
    }
  }, [company?.id, companyLoading]);

  const getLogo = (content) => {
    if (!content) return;
    setLogoLoading(true);
    let config = {
      headers: {
        Authorization: 'Bearer ' + func.getCookie('token'),
      },
    };
    axios
      .post(
        `${process.env.REACT_APP_JAVA_SERVER_URL}apiEndpoint/search`,
        {
          object: 'GetCompanyLogo',
          nuis: content.nuis,
          company: content.id,
          value: '',
        },
        config
      )
      .then((res) => {
        setLogoLoading(false);
        if (
          res.data !== '' &&
          res.data.status !== false &&
          res?.data?.content.length > 0
        ) {
          setFilePreview({ base64: res?.data?.content[0], uploaded: true });
        }
      });
  };

  const handleCompanyInputs = (e, selectKey, selectValue) => {
    const key = e ? e.target.name : selectKey;
    const value = e ? e.target.value : selectValue;
    let content = { ...company, [key]: value };
    setCompany(content);
    return content;
  };

  if (companyLoading || pageLoading) {
    return <Loader />;
  }

  return (
    <div className="settings-subpage">
      <SettingsBreadcrumb
        items={[{ label: t('settings.generalInfo') }]}
        company={company}
        isAdminMode={isAdminMode}
      />

      <div className="settings-subpage__header">
        <Link to={getBackUrl()} className="settings-subpage__back-btn">
          <FontAwesomeIcon icon={faArrowLeft} />
        </Link>
        <h2 className="settings-subpage__title">
          <span className="settings-subpage__icon">
            <FontAwesomeIcon icon={faBuilding} />
          </span>
          {t('settings.generalInfo')}
        </h2>
        {company && (
          <span className="settings-subpage__company-badge">
            {company.name}
          </span>
        )}
      </div>

      <Company
        company={company}
        setCompany={setCompany}
        handleCompanyInputs={handleCompanyInputs}
        filePreview={filePreview}
        setPageLoading={setPageLoading}
        setFilePreview={setFilePreview}
        logoLoading={logoLoading}
        editCompany={editCompany}
        getCompany={getCompany}
        getLogo={getLogo}
        isAdminMode={isAdminMode}
      />
    </div>
  );
};

export default GeneralInfoSettings;
